import React, { useState } from 'react';
import '../less/index.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../auxiliary-components/shared/HeroBlock';
import Advantages from '../../../../auxiliary-components/shared/AdvantagesBlock';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import advantages_img_5 from '../img/advantages_img_5.png';
import advantages_img_6 from '../img/advantages_img_6.png';
import Tabs from '../../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../../auxiliary-components/shared/TariffsBlock';
import CalculatorNew from '../../../../auxiliary-components/CalculatorNew';
import { premiumCardTariffs } from '../../../../services/urls/urls';
import AdditionalProduct from '../../../../auxiliary-components/shared/AdditionalProductBlock';
import FilesForDownloadNew from "../../../../auxiliary-components/shared/FilesForDownloadNew";
import TextAboveFooterNew from "../../../../auxiliary-components/shared/TextAboveFooterNew";
import QuestionsAdminNew from '../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import CardOrderModal from '../../../../auxiliary-components/CardOrderModal';
import Accordion from '../../../../auxiliary-components/shared/Accordion';
import { Preloader } from 'MWComponents';
import { canUseDOM } from '../../../../helpers/canUseDOM';
import { filterByEnvironment } from '../../../../helpers/utils/environmentFilter';
import { howToGetCardItems } from '../../enums/howToGetCardData';
import HowToBlockNew from '../../../../auxiliary-components/shared/HowToBlockNew';

export default function template() {
  const model = this.getModel();
  const page = 'premium-card-new';

  const tabs1 = [{tab: 'tariffs', title: 'PLATINUM_CARD_NEW_TABS_TITLE_01'},
          {tab: 'calculator', title: 'PLATINUM_CARD_NEW_TABS_TITLE_02'},
          {tab: 'how-to-get-card', title: 'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TAB_TITLE'}];

  const tabs2 = [{tab: 'platinum', title: 'PLATINUM_CARD_NEW_TABS_POSSIBILIES_TITLE_01'},
          {tab: 'infinite', title: 'PLATINUM_CARD_NEW_TABS_POSSIBILIES_TITLE_02'},
          {tab: 'world-elite', title: 'PLATINUM_CARD_NEW_TABS_POSSIBILIES_TITLE_03'}];

  const hero_data = {
    title: 'PLATINUM_CARD_NEW_HERO_TITLE',
    text: 'PLATINUM_CARD_NEW_HERO_TEXT',
    link: {
      text: "PLATINUM_CARD_NEW_HERO_BTN",
      onClick: () => this.toggleModal(),
    },
    cards: [
      {
        title: 'PLATINUM_CARD_NEW_CARDS_HERO_TITLE_01',
        text: 'PLATINUM_CARD_NEW_CARDS_HERO_TEXT_01',
      },
      {
        title: 'PLATINUM_CARD_NEW_CARDS_HERO_TITLE_02',
        text: 'PLATINUM_CARD_NEW_CARDS_HERO_TEXT_02',
      },
      {
        title: 'PLATINUM_CARD_NEW_CARDS_HERO_TITLE_03',
        text: 'PLATINUM_CARD_NEW_CARDS_HERO_TEXT_03',
      },
      {
        title: 'PLATINUM_CARD_NEW_CARDS_HERO_TITLE_04',
        text: 'PLATINUM_CARD_NEW_CARDS_HERO_TEXT_04',
      }
    ]
  }

  const advantagesItems = [
    {
      img: advantages_img_1,
      title: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TITLE_01',
      text: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TEXT_01',
    },
    {
      img: advantages_img_2,
      title: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TITLE_02',
      text: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TEXT_02',
    },
    {
      img: advantages_img_3,
      title: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TITLE_03',
      text: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TEXT_03',
    },
    {
      img: advantages_img_4,
      title: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TITLE_04',
      text: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TEXT_04',
    },
    {
      img: advantages_img_5,
      title: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TITLE_05',
      text: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TEXT_05',
    },
    {
      img: advantages_img_6,
      title: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TITLE_06',
      text: 'PLATINUM_CARD_NEW_CARDS_ADVANTAGES_TEXT_06',
    }
  ];

  const tariffsData = [
    {
      label: 'PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_1_1',
      value: 'PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_1_2',
    },
    {
      label: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_2_1",
      value: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_2_2",
    },
    {
      label: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_3_1",
      value: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_3_2",
    },
    {
      label: {
        html: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_4_1",
        link: {
          text: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_4_2",
          onClick: this.scrollToFrequentlyAskedQuestions,
        },
      },
      value: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_4_3",
    },
    {
      label: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_5_1",
      value: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_5_2",
    },
    {
      label: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_6_1",
      value: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_6_2",
    },
    {
      label: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_7_1",
      value: "PLATINUM_CARD_NEW_CARDS_TARIFFS_CELL_7_2",
    }
  ];

  const additionalCards = [
    {
      link: '/business/fop',
      title: 'PLATINUM_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TITLE_01',
      text: 'PLATINUM_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TEXT_01',
      textBtn: 'PLATINUM_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_LINK_01',
    },
    {
      link: '/services/safe_boxes',
      title: 'PLATINUM_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TITLE_02',
      text: 'PLATINUM_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_TEXT_02',
      textBtn: 'PLATINUM_CARD_NEW_CARDS_ADDITIONAL_PRODUCT_LINK_02',
    }
  ];

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

  const accordionItems1 = [
    {
      label: 'PLATINUM_CARD_ACCORDION_1_LABEL_1',
      value: 'PLATINUM_CARD_ACCORDION_1_VALUE_1',
      id: "accordion-platinum-concierge"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_1_LABEL_2',
      value: 'PLATINUM_CARD_ACCORDION_1_VALUE_2',
      id: "accordion-platinum-1"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_1_LABEL_3',
      value: 'PLATINUM_CARD_ACCORDION_1_VALUE_3',
      id: "accordion-platinum-2"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_1_LABEL_8',
      value: 'PLATINUM_CARD_ACCORDION_1_VALUE_8',
      id: "accordion-platinum-7"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_1_LABEL_4',
      value: 'PLATINUM_CARD_ACCORDION_1_VALUE_4',
      id: "accordion-platinum-3"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_1_LABEL_5',
      value: 'PLATINUM_CARD_ACCORDION_1_VALUE_5',
      id: "accordion-platinum-4"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_1_LABEL_6',
      value: 'PLATINUM_CARD_ACCORDION_1_VALUE_6',
      id: "accordion-platinum-5"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_1_LABEL_7',
      value: 'PLATINUM_CARD_ACCORDION_1_VALUE_7',
      id: "accordion-platinum-6"
    },
  ]

  const accordionItems2 = [
    {
      label: 'PLATINUM_CARD_ACCORDION_2_LABEL_1',
      value: 'PLATINUM_CARD_ACCORDION_2_VALUE_1',
      id: "accordion-infinite-1"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_2_LABEL_2',
      value: 'PLATINUM_CARD_ACCORDION_2_VALUE_2',
      id: "accordion-infinite-2"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_2_LABEL_3',
      value: 'PLATINUM_CARD_ACCORDION_2_VALUE_3',
      id: "accordion-infinite-3"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_2_LABEL_4',
      value: 'PLATINUM_CARD_ACCORDION_2_VALUE_4',
      id: "accordion-infinite-4"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_2_LABEL_5',
      value: 'PLATINUM_CARD_ACCORDION_2_VALUE_5',
      id: "accordion-infinite-5"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_2_LABEL_6',
      value: 'PLATINUM_CARD_ACCORDION_2_VALUE_6',
      id: "accordion-infinite-6"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_2_LABEL_7',
      value: 'PLATINUM_CARD_ACCORDION_2_VALUE_7',
      id: "accordion-infinite-7"
    },
  ]

  const accordionItems3 = [
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_1',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_1',
      id: "accordion-world-elite-1"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_2',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_2',
      id: "accordion-world-elite-2"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_3',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_3',
      id: "accordion-world-elite-3"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_4',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_4',
      id: "accordion-world-elite-4"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_5',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_5',
      id: "accordion-world-elite-5"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_6',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_6',
      id: "accordion-world-elite-6"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_7',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_7',
      id: "accordion-world-elite-7"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_8',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_8',
      id: "accordion-world-elite-8"
    },
    {
      label: 'PLATINUM_CARD_ACCORDION_3_LABEL_9',
      value: 'PLATINUM_CARD_ACCORDION_3_VALUE_9',
      id: "accordion-world-elite-9"
    },
  ]

  const allAccordionsItems = [accordionItems1, accordionItems2, accordionItems3];

  return (
    <div className="module-premium-new">
      <Hero
        data={hero_data}
        img={hero_img}
        page={page}
      />
      <div className="content">
        {!this.state.faqTab ? (
          <>
            <Advantages
              items={advantagesItems}
              title={'PLATINUM_CARD_NEW_ADVANTAGES_TITLE'}
            />
            <Tabs tabs={tabs1} toggle={this.toggleTab} tab={this.state.tab} page={page}>
              <Tariffs
                items={tariffsData}
                title={'PLATINUM_CARD_NEW_CARDS_TARIFFS_TITLE'}
                btnLink={premiumCardTariffs}
                btnText={'PLATINUM_CARD_NEW_CARDS_TARIFFS_BTN'}
                page={page}
              />
              {model.creditSum ? (
                <CalculatorNew model={model} type="credit_cards" {...this.props}/>
              ) : (canUseDOM ? <Preloader /> : null)}
              <HowToBlockNew
                title={'CARDS_COMMON_NEW_HOW_TO_GET_CARD_TITLE'}
                items={howToGetCardItems}
              />
            </Tabs>
            <Tabs title={'PLATINUM_CARD_NEW_TABS_TITLE'} tabs={tabs2} toggle={this.togglePossibilitiesTab} tab={this.state.tabPossibilities} page={page}>
              {allAccordionsItems.map((items, index) => (
                <Accordion key={index} items={items} />
              ))}
            </Tabs>
            <AdditionalProduct
              items={additionalCards}
              title={'PLATINUM_CARD_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <QuestionsAdminNew
              widget={questionsWidget}
              toggleFaqTab={this.toggleFaqTab}
              title={'FAQ_SHORT_NEW_TITLE'}
              page={page}
            />
            <FilesForDownloadNew
              lang={this.props.lang}
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
            />
            <TextAboveFooterNew
              widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')}
            />
          </>
        ) : (
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('PLATINUM_CARD_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('PLATINUM_CARD_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
        )}
      </div>
      {this.state.showModal ? 
        <CardOrderModal closeModal={this.toggleModal} product={"platinum"} isOpen={this.state.showModal}/> : ''
      }
    </div>
  );
}
